import axios, { AxiosInstance, AxiosResponse, AxiosError } from 'axios';
import { showToastError } from 'utils/toasts';

const apiAuth: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_API_URL + '/api',
  headers: {
    common: {
     "Accept": "application/json",
    }
   }
});

apiAuth.interceptors.request.use(
  (config) => {
    // Obtenha o token de autenticação do localStorage
    const authToken = localStorage.getItem('token');

    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiAuth.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    
    if (error.response?.status === 401 || error.response?.status === 419) 
    {
      // Tratamento específico para erro 401 (Unauthorized) ou 419 (Authentication Timeout)
      sessionStorage.setItem('redirect_url', window.location.pathname);
      window.location.href = '/login';

    } else if (error.response?.status === 403) 
    { 
      // Tratamento específico para erro 403 (Forbidden)
      showToastError('Você não tem acesso a esse conteúdo.');
      window.location.href = '/sem-acesso';

    } else if (error.response?.status === 450) 
    {
      // Caso seja verificado que o usuario pode selecionar mais grupos de cidades para acesso
      window.location.href = '/grupo-cidades/selecionar';

    } else if (error.response?.status === 500) 
    {
      // Tratamento específico para erro 500 (Internal Server Error)
      // console.error('Erro interno no servidor:', error?.message);
      showToastError('Algo deu errado. Tente novamente mais tarde.');
      // throw new Error('Erro interno no servidor');
    }

    throw error; // Outros erros serão tratados no ponto de uso
  }
);

export default apiAuth;
